import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const Popup = ({ isOpen, onClose, children, footer, className }: any) => {
  if (!isOpen) return null;

  const handleBackgroundClick = (event: any) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };
  return (
    <motion.div
      onClick={handleBackgroundClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className={`bg-white p-4 rounded-2xl shadow-md ${className}`}
      >
        {children}
        <div className="flex justify-end w-full gap-2">
          <button
            className="mt-4 px-4 py-2 bg-gray-400 text-white rounded-xl"
            onClick={onClose}
          >
            Đóng
          </button>
          {footer}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Popup;
